module.exports = __webpack_public_path__ + "img/no-result.9ea60ebd.svg";